<template>
    <DCard padding>
        <DFormRow
            :label="$t('users.field_name')"
        >
            {{ user.name }}
        </DFormRow>
        <DFormRow
            :label="$t('users.field_email')"
        >
            {{ user.email }}
        </DFormRow>
        <DFormRow
            :label="$t('users.field_role')"
            :is-required="true"
            :error="errors.role"
        >
            <span v-if="isProduction">{{ userRoleName }}</span>
            <DSelect
                v-else
                v-model="form.role"
                :placeholder="$t('users.role_select_placeholder')"
                :options="roles"
                :is-valid="errors.role ? false : null"
                @update:value="updateRole"
            />
        </DFormRow>
        <DFormRow
            :label="$t('users.field_owner_group')"
            :is-required="true"
            :error="errors.owner_group"
        >
            <span>{{ userOwnerGroup }}</span>
        </DFormRow>
        <DFormRow
            :label="$t('users.field_pagesize')"
            :is-required="true"
            :error="errors.ui_pagesize"
        >
            <DSelect
                v-model="form.ui_pagesize"
                :placeholder="$t('users.field_pagesize')"
                :options="uiPageSizeOptions"
                :is-valid="errors.ui_pagesize ? false : null"
                @update:value="updatePaginationSize"
            />
        </DFormRow>
        <DFormRow
            :label="$t('users.field_locale')"
            :is-required="true"
            :error="errors.locale"
        >
            <DSelect
                v-model="locale"
                :placeholder="$t('users.field_locale')"
                :options="localeOptions"
                :is-valid="errors.locale ? false : null"
                @update:value="updateLocale"
            />
        </DFormRow>
        <DFormControls
            :key="reloadKey"
            :cancel-route="$route('users.edit', {user: user.id})"
            @submit="saveUser"
        />
    </DCard>
</template>

<script>
import { router, useForm } from '@inertiajs/vue3'

export default {
    name: 'UserEdit',
    props: {
        user: {
            type: Object,
            default: () => { return {} }
        },
        isProduction: {
            type: Boolean,
            default: true
        },
        roles: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        paginationOptions: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            form: useForm({
                role: this.user.roles[0]?.id,
                ui_pagesize: this.user.ui_pagesize ?? 25
            }),
            locale: this.user.locale ?? 'en',
            reloadKey: 0
        }
    },
    computed: {
        userRoleName () {
            return this.roles.find(role => role.id === this.form.role)?.name
        },
        userOwnerGroup () {
            return this.user?.owner_group.name ?? ''
        },
        uiPageSizeOptions () {
            return this.paginationOptions.map(option => {
                return { value: option, label: option }
            })
        },
        localeOptions () {
            return [
                { value: 'en', label: 'English' },
                { value: 'de', label: 'Deutsch' }
            ]
        }
    },
    methods: {
        saveUser () {
            router.put(this.$route('users.update', { user: this.user.id }), this.form, {
                onSuccess: () => {
                    ++this.reloadKey
                }
            })
        },
        updateRole (value) {
            this.form.role = value
        },
        updatePaginationSize (value) {
            this.form.ui_pagesize = value
        },
        updateLocale (value) {
            this.locale = value
            router.patch(this.$route('users.update_locale', { user: this.user.id }), {
                locale: value
            })
        }
    }
}
</script>
